import 'bootstrap/dist/css/bootstrap.min.css'

import './FileIcon.css';

const FileIcon = ({ extension, className }) => {
    // Mapea la extensión del archivo a un icono correspondiente
    const getIconByExtension = (extension) => {
        switch (extension.toLowerCase()) {
            case 'pdf':
                return <i className="bi bi-file-pdf"></i>
            case 'doc':
                return <i className="bi bi-filetype-doc"></i>
            case 'docx':
                return <i className="bi bi-filetype-docx"></i>
            case 'xls':
              return <i className="bi bi-filetype-xls"></i>
            case 'xlsx':
                return <i className="bi bi-filetype-xlsx"></i>
            case 'txt':
                return <i className="bi bi-filetype-txt"></i>
            case 'csv':
                return <i className="bi bi-filetype-csv"></i>
            case 'json':
                return <i className="bi bi-filetype-json"></i>
            case 'mov':
                return <i className="bi bi-filetype-mov"></i>
            case 'mp3':
                return <i className="bi bi-filetype-mp3"></i>
            case 'mp4':
                return <i className="bi bi-filetype-mp4"></i>
            case 'jpg': case 'jpeg':
                return <i className="bi bi-filetype-jpg"></i>
            case 'png':
                return <i className="bi bi-filetype-png"></i>
            case 'zip':
                return <i className="bi bi-filetype-zip"></i>
            default:
                return <i className="bi bi-file-earmark"></i> // Ícono genérico para extensiones desconocidas
        }
    }

    return(
        <div className={className}>
            {getIconByExtension(extension)}
        </div>
    )
}

export default FileIcon
